export default "__VITE_ASSET__8092133a__"